import { render, staticRenderFns } from "./MassDownloadsPolicy.vue?vue&type=template&id=30d50bba&scoped=true&"
import script from "./MassDownloadsPolicy.vue?vue&type=script&lang=ts&"
export * from "./MassDownloadsPolicy.vue?vue&type=script&lang=ts&"
import style0 from "./MassDownloadsPolicy.vue?vue&type=style&index=0&id=30d50bba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d50bba",
  null
  
)

export default component.exports